import { useEffect, useState } from 'react';
import { formatDistanceToNowStrict } from 'date-fns';
import PropTypes from 'prop-types';
import {
  Avatar,
  Box,
  Link,
  List,
  ListItem,
  ListItemAvatar,
  ListItemText,
  Popover,
  Typography
} from '@mui/material';
import { StatusIndicator } from '../status-indicator';
import { db } from '../../lib/firebase';
import { getDocs, query, collection, addDoc, Timestamp, where, getDoc, doc, updateDoc } from 'firebase/firestore';

export const ContactsPopover = (props) => {
  const { anchorEl, onClose, open, ...other } = props;
  const [contactos, setContactos] = useState([])
  const [isLoaded, setIsLoaded] = useState(false)

  // Get contacts from firebase 
  async function getContactos() {
    const q = query(collection(db, "agente"));
    const querySnapshot = await getDocs(q);
    const contacts = [];
    querySnapshot.forEach((doc) => {
      contacts.push({ ...doc.data(), id: doc.id });
    });
    setContactos(contacts);
    setIsLoaded(true);
  }


  useEffect(() => {
    // Si no hay contactos en el estado, los traemos de firebase
    if (!isLoaded) {
      getContactos();
    }}, []);

  return (
    <Popover
      anchorEl={anchorEl}
      anchorOrigin={{
        horizontal: 'center',
        vertical: 'bottom'
      }}
      onClose={onClose}
      open={!!open}
      PaperProps={{
        sx: {
          p: 2,
          width: 320
        }
      }}
      transitionDuration={0}
      {...other}>
      <Typography variant="h6">
        Directorio ELAM-FAW
      </Typography>
      <Box sx={{ mt: 2 }}>
        <List disablePadding>
          {contactos?.map((contacto) => {
            return (
              <ListItem
                disableGutters
                key={contacto?.id}
              >
                <ListItemAvatar>
                  <Avatar
                    src={contacto?.photoURL}
                    sx={{ cursor: 'pointer', backgroundColor: 'transparent' }}
                  />
                </ListItemAvatar>
                <ListItemText
                  disableTypography
                  primary={(
                    <Link
                      color="textPrimary"
                      noWrap
                      sx={{ cursor: 'pointer' }}
                      underline="none"
                      variant="subtitle2"
                    >
                      {contacto?.name + ' ' + contacto?.surname}
                    </Link>
                  )}
                />
              </ListItem>
            );
          })}
        </List>
      </Box>
    </Popover>
  );
};

ContactsPopover.propTypes = {
  anchorEl: PropTypes.any,
  onClose: PropTypes.func,
  open: PropTypes.bool
};
